import AssetsTitle from './AssetsTitle';

export default AssetsTitle;
